import { BOOTSTRAP_GRID_SM_MAX } from "constants-lib/dimensions"
import find from "lodash/find"
import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

/**
 * Returns the width of the ssrWindow.
 * @function
 * @returns {number} The width of the ssrWindow.
 */
export const getWindowWidth = () =>
  Math.max(
    ssrWindow.document.documentElement.clientWidth,
    ssrWindow.innerWidth || 0,
  )

/**
 * Returns the height of the ssrWindow.
 * @function
 * @returns {number} The height of the ssrWindow.
 */
export const getWindowHeight = () =>
  Math.max(
    ssrWindow.document.documentElement.clientHeight,
    ssrWindow.innerHeight || 0,
  )

/**
 * Determines whether the current device is a desktop.
 * @function
 * @returns {boolean} Whether the current device is a desktop.
 */
export const isDesktop = () => {
  const windowWidth = getWindowWidth()
  return windowWidth > BOOTSTRAP_GRID_SM_MAX
}

/**
 * Determines whether a media query matches the current state of the device.
 * @function
 * @param {string} mediaQuery - The media query to test.
 * @returns {boolean} Whether the media query matches.
 */
export const isMediaMatch = (mediaQuery) =>
  ssrWindow.matchMedia(mediaQuery).matches

/**
 * Finds the first object in an array of objects that has a media query that matches the current state of the device.
 * @function
 * @param {Object[]} queryObjects - An array of objects with a `mediaQuery` property.
 * @returns {Object|undefined} The first object with a matching media query, or undefined if no match is found.
 */
export const firstToMatch = (queryObjects) =>
  find(queryObjects, (u) => isMediaMatch(u.mediaQuery))
